import cookieUtils from '../utils/rbmc.cookie-utils.js';
import urlUtils from '../utils/rbmc.url-utils';
import mobileNavigation from './rbmc.mobileNavigation.js';
import logger from '../utils/rbmc.logger';
import cartCounter from '../header/rbmc.cart-counter';

const subShopNavigation = {
    /**
     * @deprecated
     */
    handleNavigation() {
        // check if we have a subShop cooke -> if not we are done
        let subShopCookie = cookieUtils.readCookie('subShop');
        if (subShopCookie != null) {
            // we have a cookie -> we have to check if the current navigation is the correct one
            let currentNavigation = $('#js-replace-header').data('nav-id'),
                navigationId      = subShopCookie.split(',')[4],
                subShopCode       = subShopCookie.split(',')[0];

            logger.debug('subshop cookie available ' + subShopCookie);
            logger.debug('nav-id ' + currentNavigation);
            logger.debug('navId from cookie' + navigationId);

            if (navigationId !== currentNavigation) {
                // if the currentNavigation differs from the navigation that should be
                // we have to fetch the navigation from the backend and replace the
                // existing one
                logger.debug('fetch current navigation');
                let url = `${urlUtils.getBaseUrl()}view/CategoryNavigationComponentController/?componentUid=${navigationId}&subShop=${subShopCode}`;
                $.get(url, function (data) {
                    $('#js-replace-header').replaceWith(data);
                    // rebind mobile event handlers and move banners for mobile navigation
                    mobileNavigation.mobileMenuNavigation();
                    mobileNavigation.mobileMenuOpenClose();
                }).always(function () {
                    showNavigation();
                }).fail(function (x, e) {
                    logger.error('Fetching navigation from backend failed');
                });
            } else {
                showNavigation();
            }
        } else {
            showNavigation();
            logger.debug('no cookie -> nothing to do');
        }

        function showNavigation() {
            $('#js-replace-header > .row').fadeIn(100, () => {
                cartCounter.initCounter();
            });
        }
    }
};

export default subShopNavigation;
